export default __webpack_public_path__ + "static/media/trovity_banner.cc54ed2e.svg";